import { Suspense } from 'react';

import { Loader } from '@plot/ui';

import { useWorkspace } from '@/lib/contexts';
import Maintenance from '@/pages/maintenance';

export function Workspace() {
  const { workspace } = useWorkspace();

  return (
    <>
      <Suspense fallback={<Loader backdrop cover />}>
        {workspace?.appFlags?.geodataMaintenance ? (
          <Maintenance size={'xl'} />
        ) : null}
      </Suspense>
    </>
  );
}

export default Workspace;
